module.exports = __webpack_public_path__ + "img/employee_phone.e094c2a3.svg";